import React from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import RightArrow from "components/icons/rightarrow";
import { monthAbrv, weekdaysAbrv } from "lib/date-helpers";

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mq.lg`
  `}
`;

const DateSelecter = styled.ul`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style-type: none;
  margin: 0;
  max-width: 100%;
  padding: 0;
  position: relative;
`;

const MobileDateWrapper = styled.li`
  ${({ theme }) => theme.mq.lg`
    display: none;
  `}
  margin: 0;
`;

const DesktopDateWrapper = styled.li`
  display: none;
  ${({ theme }) => theme.mq.lg`
    display: inherit;
  `}
  margin: 0rem;
`;

const DateList = styled.ol`
  display: flex;
  margin: 0rem;
  padding-left: 0rem;
`;

const DateItem = styled.li`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100px;
`;

const DateItemSubNum = styled.div`
  font-size: ${({ theme }) => theme.fontSize(1)};
  text-align: center;
  color: ${({ theme }) => theme.themeColors.darkGreen1};
`;

const DateItemSubText = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen3};
  font-size: ${({ theme }) => theme.fontSize(0)};
  letter-spacing: 0.3px;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const DateSwitchButton = styled.button`
  background-color: transparent;
  border: transparent 0 solid;
  border-radius: 5px;
  color: ${({ theme }) => theme.themeColors.darkGreen3};
  font-size: ${({ theme }) => theme.fontSize(2)};
  height: 25px;
  margin: auto auto 0 auto;
  width: 25px;
  z-index: 1;

  :focus {
    outline: 0;
  }

  :focus-visible {
    outline: 2px solid #0070f3;
  }
`;

const DateSwitchLiWrapper = styled.li`
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${({ theme }) => theme.mq.lg`
    bottom: 10px;
    position: absolute;

    // Previous < Date Selector
    &:first-child {
      left: -12px;
    }

    // Next > Date Selector
    &:last-child {
      right: -12px;
    }
  `}
`;

const LeftArrow = styled(RightArrow)`
  transform: rotate(180deg);
`;

function DateSelector({ dateArr, theme, updateDayColumns }) {
  const today = dateArr[0] ? new Date(dateArr[0]) : new Date();
  const calculateToday = weekdaysAbrv[today.getDay()].toLowerCase();
  const calculateMonth = monthAbrv[today.getMonth()];
  const dateNum = today.getDate();
  return (
    <OuterWrapper>
      <DateSelecter>
        <DateSwitchLiWrapper>
          <DateSwitchButton onClick={() => updateDayColumns("previous")} aria-label="Previous Date">
            <LeftArrow color={theme.themeColors.secondary} height={10} />
          </DateSwitchButton>
        </DateSwitchLiWrapper>
        <MobileDateWrapper>
          <DateList>
            <DateItem>
              <DateItemSubText> {calculateToday}</DateItemSubText>
              <DateItemSubNum>
                {calculateMonth} {dateNum}
              </DateItemSubNum>
            </DateItem>
          </DateList>
        </MobileDateWrapper>
        <DesktopDateWrapper>
          <DateList>
            {dateArr?.map((date) => {
              const jDate = new Date(date);
              const calculatedDate = weekdaysAbrv[jDate.getDay()].toLowerCase();
              const calculatedMonth = monthAbrv[jDate.getMonth()];
              return (
                <DateItem key={calculatedDate}>
                  <DateItemSubText>{calculatedDate}</DateItemSubText>
                  <DateItemSubNum>
                    {calculatedMonth} {jDate.getDate()}
                  </DateItemSubNum>
                </DateItem>
              );
            })}
          </DateList>
        </DesktopDateWrapper>
        <DateSwitchLiWrapper>
          <DateSwitchButton onClick={() => updateDayColumns("next")} aria-label="Next Date">
            <RightArrow color={theme.themeColors.secondary} height={10} />
          </DateSwitchButton>
        </DateSwitchLiWrapper>
      </DateSelecter>
    </OuterWrapper>
  );
}

export default withTheme(DateSelector);

DateSelector.propTypes = {
  dateArr: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({}),
    ])
  ),
  theme: PropTypes.shape({
    themeColors: PropTypes.shape({
      secondary: PropTypes.string,
    }),
  }),
  updateDayColumns: PropTypes.func,
};

DateSelector.defaultProps = {
  dateArr: [],
  theme: {
    secondary: undefined,
  },
  updateDayColumns: () => {},
};
